<!-- filepath: src/components/SeListPageResponsive.vue -->
<template>
  <div class="header-info">
    <!-- ... header-info 내용 유지 ... -->
    <table class="header-table">
      <tbody>
        <tr>
          <th>총고객수</th>
          <td>{{ totalCustomers ? totalCustomers.toLocaleString() : "0" }}</td>
          <th>가용</th>
          <td class="avaiCus">
            {{ availableCustomers ? availableCustomers.toLocaleString() : "0" }}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="right-info">
      <input
        type="text"
        id="filter-text-box"
        placeholder="검색"
        @input="onQuickFilterChanged"
      />
    </div>
  </div>
  <div class="se-list-page-responsive">
    <!-- 오른쪽 섹션 -->
    <div class="right-section">
      <!-- 가로 배치를 위한 래퍼 추가 -->
      <!-- 오른쪽 그리드 -->
      <!-- 분석 테이블 섹션 -->
      <div class="analysis-section">
        <!-- ... analysis-table 내용 유지 ... -->
        <table class="analysis-table">
          <thead>
            <tr>
              <th>사업주분석1</th>
              <th>전월 누계</th>
              <th>전월 적자</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>전월누계</th>
              <td
                :style="{
                  color: analysisResults.lastMonth.sum > 0 ? 'red' : 'blue',
                }"
              >
                {{ analysisResults.lastMonth.sum.toLocaleString() }}
              </td>
              <td
                :style="{
                  color: analysisResults.lastMonth.negSum > 0 ? 'red' : 'blue',
                }"
              >
                {{ analysisResults.lastMonth.negSum.toLocaleString() }}
              </td>
            </tr>
            <tr>
              <th>점포수</th>
              <td>{{ analysisResults.lastMonth.count.toLocaleString() }}</td>
              <td>
                {{ analysisResults.lastMonth.negCount.toLocaleString() }}
              </td>
            </tr>
            <tr>
              <th>비율</th>
              <td>{{ analysisResults.lastMonth.ratio.toFixed(1) }}%</td>
              <td>{{ analysisResults.lastMonth.negRatio.toFixed(1) }}%</td>
            </tr>
            <tr>
              <th>당월</th>
              <td
                :style="{
                  color: analysisResults.currentMonth.sum > 0 ? 'red' : 'blue',
                }"
              >
                {{ analysisResults.currentMonth.sum.toLocaleString() }}
              </td>
              <td
                :style="{
                  color:
                    analysisResults.currentMonth.negSum > 0 ? 'red' : 'blue',
                }"
              >
                {{ analysisResults.currentMonth.negSum.toLocaleString() }}
              </td>
            </tr>
            <tr>
              <th>점포수</th>
              <td>
                {{ analysisResults.currentMonth.count.toLocaleString() }}
              </td>
              <td>
                {{ analysisResults.currentMonth.negCount.toLocaleString() }}
              </td>
            </tr>
            <tr>
              <th>비율</th>
              <td>{{ analysisResults.currentMonth.ratio.toFixed(1) }}%</td>
              <td>{{ analysisResults.currentMonth.negRatio.toFixed(1) }}%</td>
            </tr>
          </tbody>
        </table>

        <table class="analysis-table">
          <thead>
            <tr>
              <th>사업주분석2</th>
              <th>흑자사업주</th>
              <th>적자사업주</th>
            </tr>
          </thead>
          <tbody>
            <!-- 당월 흑자 섹션 -->
            <tr>
              <th>흑자</th>
              <td
                :style="{
                  color:
                    analysisResults.analysis2.lastPositive.currentPositiveSum >
                    0
                      ? 'red'
                      : 'blue',
                }"
              >
                {{
                  analysisResults.analysis2.lastPositive.currentPositiveSum.toLocaleString()
                }}
              </td>
              <td
                :style="{
                  color:
                    analysisResults.analysis2.lastNegative.currentPositiveSum >
                    0
                      ? 'red'
                      : 'blue',
                }"
              >
                {{
                  analysisResults.analysis2.lastNegative.currentPositiveSum.toLocaleString()
                }}
              </td>
            </tr>
            <tr>
              <th>점포수</th>
              <td>
                {{
                  analysisResults.analysis2.lastPositive.currentPositiveCount.toLocaleString()
                }}
              </td>
              <td>
                {{
                  analysisResults.analysis2.lastNegative.currentPositiveCount.toLocaleString()
                }}
              </td>
            </tr>
            <tr>
              <th>비율</th>
              <td>
                {{
                  analysisResults.analysis2.lastPositive.currentPositiveRatio.toFixed(
                    1
                  )
                }}%
              </td>
              <td>
                {{
                  analysisResults.analysis2.lastNegative.currentPositiveRatio.toFixed(
                    1
                  )
                }}%
              </td>
            </tr>
            <!-- 당월 적자 섹션 -->
            <tr>
              <th>적자</th>
              <td
                :style="{
                  color:
                    analysisResults.analysis2.lastPositive.currentNegativeSum >
                    0
                      ? 'red'
                      : 'blue',
                }"
              >
                {{
                  analysisResults.analysis2.lastPositive.currentNegativeSum.toLocaleString()
                }}
              </td>
              <td
                :style="{
                  color:
                    analysisResults.analysis2.lastNegative.currentNegativeSum >
                    0
                      ? 'red'
                      : 'blue',
                }"
              >
                {{
                  analysisResults.analysis2.lastNegative.currentNegativeSum.toLocaleString()
                }}
              </td>
            </tr>
            <tr>
              <th>점포수</th>
              <td>
                {{
                  analysisResults.analysis2.lastPositive.currentNegativeCount.toLocaleString()
                }}
              </td>
              <td>
                {{
                  analysisResults.analysis2.lastNegative.currentNegativeCount.toLocaleString()
                }}
              </td>
            </tr>
            <tr>
              <th>비율</th>
              <td>
                {{
                  analysisResults.analysis2.lastPositive.currentNegativeRatio.toFixed(
                    1
                  )
                }}%
              </td>
              <td>
                {{
                  analysisResults.analysis2.lastNegative.currentNegativeRatio.toFixed(
                    1
                  )
                }}%
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ag-grid-vue
        class="ag-theme-balham grid-common"
        :theme="theme"
        :rowData="rowData1"
        :columnDefs="columnDefs1"
        :defaultColDef="defaultColDef"
        :gridOptions="gridOptions"
        @grid-ready="(params) => onGridReady('gridApi1', params)"
        @cell-clicked="onCellClicked"
        groupIncludeFooter="true"
        groupIncludeTotalFooter="true"
        :pinnedBottomRowData="pinnedBottomRow"
        :rowHeight="rowHeight"
      ></ag-grid-vue>
    </div>

    <!-- 왼쪽 섹션 (아래로 이동) -->
    <div class="left-section">
      <ag-grid-vue
        class="ag-theme-balham grid-common"
        :theme="theme"
        :rowData="rowData2"
        :columnDefs="columnDefs2"
        :defaultColDef="defaultColDef"
        :gridOptions="gridOptions"
        @grid-ready="(params) => onGridReady('gridApi2', params)"
        :rowHeight="rowHeight"
      ></ag-grid-vue>

      <!-- 펼치기/접기 테이블 컨테이너 -->
      <div class="main-table-container" :class="{ expanded: isExpanded }">
        <!-- 메인 달력 테이블 -->
        <!-- ... main-table 내용 유지 ... -->
        <table class="main-table">
          <thead>
            <tr>
              <th>목표입력</th>
              <th>항목</th>
              <th>주간</th>
              <th>일</th>
              <th>월</th>
              <th>화</th>
              <th>수</th>
              <th>목</th>
              <th>금</th>
              <th>토</th>
            </tr>
          </thead>
          <!-- 로딩 중 -->
          <tbody v-if="mainTableLoading">
            <tr>
              <td :colspan="10">데이터 로딩 중...</td>
            </tr>
          </tbody>
          <!-- 데이터 있음 -->
          <tbody
            v-else-if="
              weeklySalesData.qtyWeeks && weeklySalesData.qtyWeeks.length > 0
            "
          >
            <!-- 수량 행 -->
            <template
              v-for="(qtyWeek, index) in weeklySalesData.qtyWeeks"
              :key="'week-group-qty-' + index"
            >
              <tr>
                <td
                  v-if="index === 0"
                  style="color: red; background-color: #d0d0d0"
                >
                  월목표
                </td>
                <td v-if="index === 1" :rowspan="2">
                  {{ summaryInfo.monthlyGoalQty?.toLocaleString() || "-" }}
                </td>
                <td v-if="index === 3">오늘목표</td>
                <td v-if="index === 4" :rowspan="3">
                  {{ summaryInfo.dailyGoalQty?.toLocaleString() || "-" }}
                </td>
                <td
                  v-if="index === 0"
                  :rowspan="weeklySalesData.qtyWeeks.length + 1"
                >
                  수량
                </td>
                <td>{{ qtyWeek.week }}주</td>
                <td>{{ qtyWeek.sun || "" }}</td>
                <td>{{ qtyWeek.mon || "" }}</td>
                <td>{{ qtyWeek.tue || "" }}</td>
                <td>{{ qtyWeek.wed || "" }}</td>
                <td>{{ qtyWeek.thu || "" }}</td>
                <td>{{ qtyWeek.fri || "" }}</td>
                <td>{{ qtyWeek.sat || "" }}</td>
              </tr>
            </template>
            <tr>
              <td colspan="2">누계</td>
              <td colspan="2">
                {{ summaryInfo.totalQty?.toLocaleString() || "-" }}
              </td>
              <td colspan="2">예상</td>
              <td colspan="2">
                {{ summaryInfo.projectedQtySum?.toLocaleString() || "-" }}
              </td>
            </tr>
            <!-- 점수 행 -->
            <template
              v-for="(pointWeek, index) in weeklySalesData.pointWeeks"
              :key="'week-group-point-' + index"
            >
              <tr>
                <td v-if="index === 0">월목표</td>
                <td v-if="index === 1" :rowspan="2">
                  {{ summaryInfo.monthlyGoalPoints?.toLocaleString() || "-" }}
                </td>
                <td v-if="index === 3">오늘목표</td>
                <td v-if="index === 4" :rowspan="3">
                  {{ summaryInfo.dailyGoalPoints?.toLocaleString() || "-" }}
                </td>
                <td
                  v-if="index === 0"
                  :rowspan="weeklySalesData.pointWeeks.length + 1"
                >
                  점수
                </td>
                <td>{{ pointWeek.week }}주</td>
                <td>{{ pointWeek.sun || "" }}</td>
                <td>{{ pointWeek.mon || "" }}</td>
                <td>{{ pointWeek.tue || "" }}</td>
                <td>{{ pointWeek.wed || "" }}</td>
                <td>{{ pointWeek.thu || "" }}</td>
                <td>{{ pointWeek.fri || "" }}</td>
                <td>{{ pointWeek.sat || "" }}</td>
              </tr>
            </template>
            <tr>
              <td colspan="2">누계</td>
              <td colspan="2">
                {{ summaryInfo.totalPoints?.toLocaleString() || "-" }}
              </td>
              <td colspan="2">예상</td>
              <td colspan="2">
                {{ summaryInfo.projectedPointSum?.toLocaleString() || "-" }}
              </td>
            </tr>
            <!-- 인원적합도 행 -->
            <template
              v-for="(matchWeek, index) in weeklySalesData.matchWeeks"
              :key="'week-group-match-' + index"
            >
              <tr>
                <td v-if="index === 0">근무TO</td>
                <td v-if="index === 1">
                  {{ summaryInfo.personnelTO || "-" }}
                </td>
                <td v-if="index === 2">근무</td>
                <td v-if="index === 3">
                  {{ summaryInfo.personnelActual || "-" }}
                </td>
                <td v-if="index === 4">오늘적합도</td>
                <td v-if="index === 5" :rowspan="2">
                  {{ summaryInfo.todayMatch || "-" }}
                </td>
                <td
                  v-if="index === 0"
                  :rowspan="weeklySalesData.matchWeeks.length + 1"
                >
                  인원적합도
                </td>
                <td>{{ matchWeek.week }}주</td>
                <td>{{ matchWeek.sun || "" }}</td>
                <td>{{ matchWeek.mon || "" }}</td>
                <td>{{ matchWeek.tue || "" }}</td>
                <td>{{ matchWeek.wed || "" }}</td>
                <td>{{ matchWeek.thu || "" }}</td>
                <td>{{ matchWeek.fri || "" }}</td>
                <td>{{ matchWeek.sat || "" }}</td>
              </tr>
            </template>
            <tr>
              <td colspan="2">누계</td>
              <td colspan="2">
                {{ summaryInfo.totalMatch?.toLocaleString() || "-" }}
              </td>
              <td colspan="2">평균</td>
              <td colspan="2">
                {{ summaryInfo.avgMatch || "-" }}
              </td>
            </tr>
          </tbody>
          <!-- 데이터 없음 -->
          <tbody v-else>
            <tr>
              <td :colspan="10">데이터가 없습니다.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- 펼치기/접기 버튼 -->
      <div class="toggle-button-container">
        <button @click="toggleExpand" class="toggle-button">
          {{ isExpanded ? "접기" : "펼치기" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import axios from "axios";
import "ag-grid-community/styles/ag-grid.css";
// 테마 import 경로는 프로젝트 구조에 맞게 확인 필요
import { themeBalham } from "ag-grid-community";

export default {
  name: "SeListPageResponsive", // 컴포넌트 이름 변경
  components: {
    AgGridVue,
  },
  data() {
    return {
      theme: themeBalham, // 테마 CSS를 직접 import 하므로 제거하거나 주석 처리
      // theme: "ag-theme-balham", // 클래스 이름으로 테마 지정

      gridApi1: null, // 오른쪽 그리드 API
      gridApi2: null, // 왼쪽 그리드 API
      gridColumnApi1: null,
      gridColumnApi2: null,

      rowData1: [],
      rowData2: [],
      mainTableData: [],
      totalCustomers: 0,
      availableCustomers: 0,
      isExpanded: false,
      mainTableLoading: false, // 메인 테이블 로딩 상태 추가

      selectedShop: null, // 선택된 매장 정보 저장

      // --- columnDefs1 (오른쪽 그리드) ---
      columnDefs1: [
        {
          headerName: "",
          field: "rowIndex",
          valueGetter: "node.rowIndex + 1",
          sortable: false,
          cellStyle: { color: "black", "background-color": "#f0f0f0" },
          minWidth: 40,
          maxWidth: 50,
          width: 40,
        },
        {
          headerName: "점번",
          field: "VAN_BIZ_NO",
          minWidth: 60,
          maxWidth: 100,
          width: 60,
          colSpan: (params) =>
            params.data && params.data.VAN_BIZ_NO.includes("합계") ? 2 : 1,
        },
        { headerName: "점명", field: "SHOP_NM", width: 83 },
        {
          headerName: "당월 수익",
          field: "PROFIT",
          valueFormatter: (params) => Number(params.value).toLocaleString(),
          cellStyle: (params) =>
            params.value < 0 ? { color: "blue" } : { color: "red" },
          minWidth: 65,
          width: 60,
        },
        {
          headerName: "전월 실선미",
          field: "LASTPROFIT",
          valueFormatter: (params) => Number(params.value).toLocaleString(),
          cellStyle: { color: "red" },
          minWidth: 80,
          width: 80,
        },
        {
          headerName: "사업 보증금 합계",
          field: "TOTALPROFITSUM",
          wrapHeaderText: true,
          valueGetter: (params) =>
            (params.data.LASTPROFIT || 0) - (params.data.PROFIT || 0),
          valueFormatter: (params) => Number(params.value).toLocaleString(),
          cellStyle: { color: "red" },
          minWidth: 80,
          width: 80,
          colSpan: (params) =>
            params.data && params.data.VAN_BIZ_NO.includes("합계") ? 2 : 1,
        },
        {
          headerName: "운영방식",
          wrapHeaderText: true,
          field: "TRBIZ_TYPE",
          minWidth: 50,
          width: 50,
        },
      ],

      // --- columnDefs2 (왼쪽 그리드) ---
      columnDefs2: [
        {
          headerName: "",
          field: "year",
          pinned: "left",
          width: 100,
          cellStyle: {},
        },
        // 월별 컬럼 정의 (반복 줄이기 위해 함수 사용 고려 가능)
        ...[...Array(12).keys()].map((i) => ({
          headerName: `${i + 1}월`,
          field: `${i + 1}month`,
          width: 60, // 너비 조정
          valueFormatter: (params) =>
            isNaN(params.value)
              ? params.value
              : Number(params.value).toLocaleString(),
          cellStyle: this.getMonthlyCellStyle, // 스타일 함수 분리
        })),
        {
          headerName: "합계",
          field: "totalCnt",
          width: 70, // 너비 조정
          valueFormatter: (params) =>
            isNaN(params.value)
              ? params.value
              : Number(params.value).toLocaleString(),
          cellStyle: this.getMonthlyCellStyle, // 스타일 함수 분리
        },
      ],

      defaultColDef: {
        resizable: true,
        sortable: true,
        wrapHeaderText: true,
        // filter: true, // 필요시 필터 활성화
      },

      gridOptions: {
        quickFilterText: "",
        suppressNoRowsOverlay: true,
        // loadingOverlayComponent: 'agLoadingOverlay', // 필요시 로딩 오버레이 설정
        getRowStyle: this.getRowStyleForGrid2, // 왼쪽 그리드 행 스타일 함수 분리
      },

      rowHeight: 18, // 행 높이 조정

      summaryInfo: {
        // 초기화 필요
        monthlyGoalQty: null,
        dailyGoalQty: null,
        monthlyGoalPoints: null,
        dailyGoalPoints: null,
        personnelTO: null,
        personnelActual: null,
        todayMatch: null,
        totalQty: 0,
        totalPoints: 0,
        totalMatch: 0,
        projectedQtySum: null,
        projectedPointSum: null,
        avgMatch: null,
        currentDayOfMonth: new Date().getDate(),
        lastDayOfMonth: new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0
        ).getDate(),
      },
    };
  },
  computed: {
    // --- 기존 computed 속성들 ---
    lastProfitTotal() {
      if (!this.rowData1 || this.rowData1.length === 0) return 0;
      return this.rowData1.reduce((sum, row) => {
        const lastProfit = Number(row.LASTPROFIT) || 0;
        const profit = Number(row.PROFIT) || 0;
        // 원본 로직은 LASTPROFIT - PROFIT 이었으나, 합계 행에서는 LASTPROFIT만 사용하므로 확인 필요
        // 여기서는 원본 코드의 pinnedBottomRow 계산 로직(lastProfit + profit)을 따름
        // 만약 합계 행의 LASTPROFIT 컬럼에 lastProfit - profit 합계를 넣으려면 수정 필요
        return sum + (lastProfit + profit); // 원본 pinnedBottomRow 계산 방식 유지
      }, 0);
    },

    pinnedBottomRow() {
      const totalProfitSum = this.rowData1.reduce(
        (sum, row) =>
          sum + ((Number(row.LASTPROFIT) || 0) - (Number(row.PROFIT) || 0)),
        0
      );
      const totalLastProfit = this.rowData1.reduce(
        (sum, row) => sum + (Number(row.LASTPROFIT) || 0),
        0
      );
      const totalProfit = this.rowData1.reduce(
        (sum, row) => sum + (Number(row.PROFIT) || 0),
        0
      );

      return [
        {
          VAN_BIZ_NO: "합계",
          SHOP_NM: null, // 점명은 비움
          PROFIT: totalProfit, // 당월 수익 합계
          LASTPROFIT: totalLastProfit, // 전월 실선미 합계
          TOTALPROFITSUM: totalProfitSum, // 사업 보증금 합계 (차이 합계)
          TRBIZ_TYPE: null, // 운영방식 비움
        },
      ];
    },

    analysisResults() {
      let lMonthMin = 0,
        lMonthMinStoreCount = 0,
        lMonthPlus = 0,
        lMonthPlusStoreCount = 0;
      let lTotalMin = 0,
        lTotalMinStoreCount = 0,
        lTotalPlus = 0,
        lTotalPlusStoreCount = 0;
      let lMPSum = 0,
        lMPCnt = 0,
        lMMSum = 0,
        lMMCnt = 0;
      let lPPSum = 0,
        lPPCnt = 0,
        lPMSum = 0,
        lPMCnt = 0;
      const totalStoreCount = this.rowData1.length;

      const defaultGroup = {
        currentPositiveSum: 0,
        currentPositiveCount: 0,
        currentPositiveRatio: 0,
        currentNegativeSum: 0,
        currentNegativeCount: 0,
        currentNegativeRatio: 0,
      };
      const defaultResult = {
        lastMonth: {
          sum: 0,
          count: 0,
          ratio: 0,
          negSum: 0,
          negCount: 0,
          negRatio: 0,
        },
        currentMonth: {
          sum: 0,
          count: 0,
          ratio: 0,
          negSum: 0,
          negCount: 0,
          negRatio: 0,
        },
        analysis2: {
          lastPositive: { ...defaultGroup },
          lastNegative: { ...defaultGroup },
        },
        totalStoreCount: 0,
      };

      if (!this.rowData1 || totalStoreCount === 0) return defaultResult;

      this.rowData1.forEach((row) => {
        const profit = Number(row.PROFIT) || 0;
        const lastProfit = Number(row.LASTPROFIT) || 0;

        if (profit <= 0) {
          lMonthMin += profit;
          lMonthMinStoreCount++;
        } else {
          lMonthPlus += profit;
          lMonthPlusStoreCount++;
        }
        if (lastProfit <= 0) {
          lTotalMin += lastProfit;
          lTotalMinStoreCount++;
          if (profit > 0) {
            lMPSum += profit;
            lMPCnt++;
          } else {
            lMMSum += profit;
            lMMCnt++;
          }
        } else {
          lTotalPlus += lastProfit;
          lTotalPlusStoreCount++;
          if (profit > 0) {
            lPPSum += profit;
            lPPCnt++;
          } else {
            lPMSum += profit;
            lPMCnt++;
          }
        }
      });

      const safeRatio = (count, total) =>
        total === 0 ? 0 : (count / total) * 100;
      const lastPositiveTotalCount = lPPCnt + lPMCnt;
      const lastNegativeTotalCount = lMPCnt + lMMCnt;

      return {
        totalStoreCount: totalStoreCount,
        lastMonth: {
          sum: lTotalPlus,
          count: lTotalPlusStoreCount,
          ratio: safeRatio(lTotalPlusStoreCount, totalStoreCount),
          negSum: lTotalMin,
          negCount: lTotalMinStoreCount,
          negRatio: safeRatio(lTotalMinStoreCount, totalStoreCount),
        },
        currentMonth: {
          sum: lMonthPlus,
          count: lMonthPlusStoreCount,
          ratio: safeRatio(lMonthPlusStoreCount, totalStoreCount),
          negSum: lMonthMin,
          negCount: lMonthMinStoreCount,
          negRatio: safeRatio(lMonthMinStoreCount, totalStoreCount),
        },
        analysis2: {
          lastPositive: {
            currentPositiveSum: lPPSum,
            currentPositiveCount: lPPCnt,
            currentPositiveRatio: safeRatio(lPPCnt, lastPositiveTotalCount),
            currentNegativeSum: lPMSum,
            currentNegativeCount: lPMCnt,
            currentNegativeRatio: safeRatio(lPMCnt, lastPositiveTotalCount),
          },
          lastNegative: {
            currentPositiveSum: lMPSum,
            currentPositiveCount: lMPCnt,
            currentPositiveRatio: safeRatio(lMPCnt, lastNegativeTotalCount),
            currentNegativeSum: lMMSum,
            currentNegativeCount: lMMCnt,
            currentNegativeRatio: safeRatio(lMMCnt, lastNegativeTotalCount),
          },
        },
      };
    },

    weeklySalesData() {
      if (!this.mainTableData || this.mainTableData.length === 0) {
        return { qtyWeeks: [], pointWeeks: [], matchWeeks: [] };
      }

      const sortedData = [...this.mainTableData].sort((a, b) =>
        a.YYYYMMDD.localeCompare(b.YYYYMMDD)
      );
      const qtyWeeks = [],
        pointWeeks = [],
        matchWeeks = [];
      let currentWeekNum = 1;
      let currentQtyWeek = this.createEmptyWeek(currentWeekNum);
      let currentPointWeek = this.createEmptyWeek(currentWeekNum);
      let currentMatchWeek = this.createEmptyWeek(currentWeekNum);
      let weekHasData = false;
      const dayMap = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];

      const firstDayOfMonth = new Date(
        parseInt(sortedData[0].YYYYMMDD.substring(0, 4)),
        parseInt(sortedData[0].YYYYMMDD.substring(4, 6)) - 1,
        1
      ).getDay();

      sortedData.forEach((dayData) => {
        const dayOfMonth = parseInt(dayData.YYYYMMDD.substring(6, 8));
        const dayOfWeekIndex = parseInt(dayData.D) - 1; // D 컬럼이 요일(1=일요일)이라고 가정
        const dayKey = dayMap[dayOfWeekIndex];
        const weekOfMonth =
          Math.floor((dayOfMonth - 1 + firstDayOfMonth) / 7) + 1;

        if (weekOfMonth > currentWeekNum && weekHasData) {
          qtyWeeks.push(currentQtyWeek);
          pointWeeks.push(currentPointWeek);
          matchWeeks.push(currentMatchWeek);
          currentWeekNum = weekOfMonth;
          currentQtyWeek = this.createEmptyWeek(currentWeekNum);
          currentPointWeek = this.createEmptyWeek(currentWeekNum);
          currentMatchWeek = this.createEmptyWeek(currentWeekNum);
          weekHasData = false;
        }
        if (!weekHasData) {
          // 첫 데이터 또는 새 주 시작 시 주차 설정
          currentWeekNum = weekOfMonth;
          currentQtyWeek.week = currentWeekNum;
          currentPointWeek.week = currentWeekNum;
          currentMatchWeek.week = currentWeekNum;
        }

        const saleQty = parseInt(dayData.SALE_QTY || 0);
        const sumPointDay = parseFloat(dayData.SUM_POINT_DAY || 0);
        const matchValue = parseInt(dayData.MATCH || 0);

        currentQtyWeek[dayKey] = saleQty;
        currentPointWeek[dayKey] = Math.round(sumPointDay).toLocaleString(); // 점수는 포맷팅
        currentMatchWeek[dayKey] = matchValue;

        // 주간 합계는 계산용으로 포맷팅 없이 누적 (필요시)
        currentQtyWeek.qtySum = (currentQtyWeek.qtySum || 0) + saleQty;
        currentPointWeek.pointSum =
          (currentPointWeek.pointSum || 0) + sumPointDay;
        currentMatchWeek.matchSum =
          (currentMatchWeek.matchSum || 0) + matchValue;

        weekHasData = true;
      });

      if (weekHasData) {
        qtyWeeks.push(currentQtyWeek);
        pointWeeks.push(currentPointWeek);
        matchWeeks.push(currentMatchWeek);
      }

      while (qtyWeeks.length < 6) {
        const weekNum = qtyWeeks.length + 1;
        qtyWeeks.push(this.createEmptyWeek(weekNum));
        pointWeeks.push(this.createEmptyWeek(weekNum));
        matchWeeks.push(this.createEmptyWeek(weekNum));
      }
      return { qtyWeeks, pointWeeks, matchWeeks };
    },
  },
  created() {
    this.loadInitialData();
  },
  methods: {
    // --- 기존 methods ---
    async loadInitialData() {
      try {
        const response = await axios.get("/api/seListPage");
        this.rowData1 = response.data;
        // 초기 로드 시 첫 번째 매장 데이터 자동 조회 (선택 사항)
        // if (this.rowData1 && this.rowData1.length > 0) {
        //   this.selectShop(this.rowData1[0]);
        // }
      } catch (err) {
        console.error("초기 데이터 로드 오류:", err);
      }
    },

    onGridReady(apiName, params) {
      // apiName 추가하여 구분
      this[apiName] = params.api;
      // this[`${apiName.replace("Api", "ColumnApi")}`] = params.columnApi;
      // params.api.autoSizeAllColumns(); // 화면에 맞게 열 크기 조정
      params.api.sizeColumnsToFit(); // 초기 로드시 컬럼 크기 자동 조정 (반응형에서는 주의)
      // 창 크기 변경 시 자동 조정 리스너는 반응형 레이아웃과 충돌할 수 있으므로 필요시 조건부로 추가
      window.addEventListener("resize", () => params.api.sizeColumnsToFit()); // 창 크기 변경 시 적용
    },

    onQuickFilterChanged(event) {
      const filterValue = event.target.value;
      // 두 그리드 모두에 필터 적용 (필요에 따라 선택적 적용)
      if (this.gridApi1)
        this.gridApi1.setGridOption("quickFilterText", filterValue);
      if (this.gridApi2)
        this.gridApi2.setGridOption("quickFilterText", filterValue);
    },

    onCellClicked(event) {
      if (event.node && event.data) {
        event.node.setSelected(true);
        this.selectShop(event.data); // 선택 로직 함수화
      }
    },

    // 매장 선택 시 데이터 로드 함수
    selectShop(shopData) {
      this.selectedShop = {
        VAN_BIZ_NO: shopData.VAN_BIZ_NO,
        SHOP_NM: shopData.SHOP_NM,
        SHOP_CD: shopData.SHOP_CD, // SHOP_CD도 저장
      };
      this.details(shopData.SHOP_CD);
      this.storeTotMem(shopData.SHOP_CD);
      this.monthSaleQtyData(shopData.SHOP_CD);
    },

    async details(shopCd) {
      try {
        const response = await axios.get(
          `/api/seListPage/details?shopCd=${shopCd}`
        );
        this.rowData2 = this.transformData(response.data);
      } catch (error) {
        console.error("상세 데이터 조회 오류:", error);
        this.rowData2 = []; // 오류 시 초기화
      }
    },

    async storeTotMem(shopCd) {
      try {
        const currentDate = new Date();
        const currentYearMonth = `${currentDate.getFullYear()}-${String(
          currentDate.getMonth() + 1
        ).padStart(2, "0")}`;
        const response = await axios.get(
          `/api/seListPage/storeTotMem?year=${currentYearMonth}&shopCd=${shopCd}`
        );
        this.totalCustomers = Number(response.data.CST_TOT_CNT) || 0;
        this.availableCustomers = Number(response.data.DIFFERENCE) || 0;
      } catch (error) {
        console.error("고객 정보 조회 오류:", error);
        this.totalCustomers = 0; // 오류 시 초기화
        this.availableCustomers = 0;
      }
    },

    transformData(data) {
      const transformed = {};
      const currentYear = new Date().getFullYear();
      const maxSaleQtyByMonth = {}; // 월별 최고 판매수량 (현재 연도 -1년까지)

      if (!Array.isArray(data)) {
        console.error("transformData: 입력 데이터가 배열이 아닙니다.", data);
        return [];
      }

      // 데이터 구조 초기화 함수
      const initializeYearData = (year) => {
        const base = {
          ownerName: { year: `${year} (사업주명)` },
          salesQty: { year: `${year} (판매수량)` },
          qtyDiff: { year: `${year} (수량차이)` },
        };
        if (year >= currentYear - 1) {
          base.averaScore = { year: `${year} (평균점수)` };
          base.auditDate = { year: `${year} (감사일자)` };
        }
        if (year === currentYear) {
          base.manageGuid = { year: `${year} (경영지도)` };
          base.branchManager = { year: `${year} (부점장명)` };
          base.maxQty = { year: `${year} (최고수량)` }; // 현재 연도에만 최고수량 행 추가
        }
        return base;
      };

      // 1. 데이터 순회 및 기본 정보 채우기
      data.forEach((row) => {
        if (!row || !row.SALE_MM) return;
        const year = parseInt(row.SALE_MM.substring(0, 4));
        const month = parseInt(row.SALE_MM.substring(4, 6));
        const monthKey = `${month}month`;

        if (!transformed[year]) {
          transformed[year] = initializeYearData(year);
        }

        // 월별 최고 판매수량 기록 (현재 연도 -1년까지 데이터만 사용)
        if (year <= currentYear - 1) {
          const currentQty = parseInt(row.SALE_QTY) || 0;
          if (
            !maxSaleQtyByMonth[month] ||
            maxSaleQtyByMonth[month] < currentQty
          ) {
            maxSaleQtyByMonth[month] = currentQty;
          }
        }

        // 데이터 채우기
        transformed[year].ownerName[monthKey] = row.SHOP_MASTER_NM;
        transformed[year].salesQty[monthKey] = Math.round(row.SALE_QTY || 0);

        if (year >= currentYear - 1) {
          transformed[year].auditDate[monthKey] = row.AUDIT_DATE;
          transformed[year].averaScore[monthKey] = Math.round(
            row.SALE_SCORE_AVG || 0
          );
        }
        if (year === currentYear) {
          transformed[year].manageGuid[monthKey] = row.SHOP_CEO_NM;
          transformed[year].branchManager[monthKey] = row.SHOP_MANAGER_NM;
          // 현재 연도 최고수량 행에 월별 최고값 채우기 (아래에서 계산 후 채움)
        }
        // qtyDiff는 아래에서 계산
      });

      // 2. 수량차이 및 현재 연도 최고수량 계산
      Object.keys(transformed)
        .sort()
        .forEach((yearStr) => {
          const year = parseInt(yearStr);
          if (!transformed[year].salesQty) return; // salesQty 없으면 건너뜀

          for (let month = 1; month <= 12; month++) {
            const monthKey = `${month}month`;
            const currentSaleQty = parseInt(
              transformed[year].salesQty[monthKey] || 0
            );

            // 이전 5개년 중 최고 판매수량 찾기
            let maxPrevQty = 0;
            for (
              let prevYear = Math.max(currentYear - 5, year - 5);
              prevYear < year;
              prevYear++
            ) {
              // 현재 연도 이전 년도들의 판매 수량 중 최대값 찾기
              const prevQty = parseInt(
                transformed[prevYear]?.salesQty?.[monthKey] || 0
              );
              if (prevQty > maxPrevQty) {
                maxPrevQty = prevQty;
              }
            }
            // 현재 연도 -5년 ~ 현재 연도 -1년까지의 최고 수량
            const historicalMaxQty = maxSaleQtyByMonth[month] || 0;

            // 수량차이 계산 (현재 판매량 - 과거 최고 판매량)
            // 과거 최고 판매량은 현재 연도 이전 년도들의 최고값과, -1년까지의 전체 최고값 중 더 큰 것을 사용
            const relevantMaxQty = Math.max(maxPrevQty, historicalMaxQty);
            transformed[year].qtyDiff[monthKey] =
              currentSaleQty - relevantMaxQty;

            // 현재 연도의 '최고수량' 행 채우기
            if (year === currentYear) {
              transformed[year].maxQty[monthKey] = historicalMaxQty; // -1년까지의 최고값 사용
            }
          }
        });

      // 3. 합계 계산
      Object.keys(transformed).forEach((year) => {
        Object.keys(transformed[year]).forEach((type) => {
          if (type !== "year" && typeof transformed[year][type] === "object") {
            // year 필드 제외하고 객체만
            const row = transformed[year][type];
            row["totalCnt"] = Object.keys(row)
              .filter((key) => key !== "year" && key !== "totalCnt")
              .reduce((sum, key) => sum + (parseInt(row[key]) || 0), 0);
          }
        });
      });

      // 4. 결과를 배열로 변환 (연도 내림차순 정렬)
      return Object.keys(transformed)
        .sort((a, b) => b - a) // 연도 내림차순 정렬
        .flatMap((year) => Object.values(transformed[year]));
    },

    async monthSaleQtyData(shopCd) {
      this.mainTableLoading = true;
      this.mainTableData = null;
      this.resetSummaryInfo();

      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth() + 1;
      const day = today.getDate();
      const startDate = `${year}${String(month).padStart(2, "0")}01`;
      const thisDate = `${year}${String(month).padStart(2, "0")}${String(
        day
      ).padStart(2, "0")}`;

      try {
        const response = await axios.get("/api/seListPage/monthSaleQtyData", {
          params: { shopCd, startDate, thisDate },
        });
        if (
          response.data &&
          Array.isArray(response.data) &&
          response.data.length > 0
        ) {
          this.mainTableData = response.data;
          this.processSummaryData(this.mainTableData);
          this.isExpanded = true; // 데이터 있으면 펼침
        } else {
          this.mainTableData = [];
          this.isExpanded = false; // 데이터 없으면 접음
        }
      } catch (error) {
        console.error("월별 판매 데이터 조회 오류:", error);
        this.mainTableData = [];
        this.isExpanded = false;
      } finally {
        this.mainTableLoading = false;
      }
    },

    processSummaryData(data) {
      if (!data || data.length === 0) return;

      const firstRecord = data[0];
      const todayString = new Date().toLocaleDateString("sv").replace(/-/g, "");
      const todayData = data.find((d) => d.YYYYMMDD === todayString);

      this.summaryInfo.monthlyGoalQty = firstRecord.ZB_GOAL_MM;
      this.summaryInfo.dailyGoalQty = firstRecord.ZB_GOAL_DD;
      this.summaryInfo.monthlyGoalPoints = parseFloat(
        firstRecord.ZA_MNGOAL || 0
      );

      const monthlyGoalPointsNum = this.summaryInfo.monthlyGoalPoints;
      this.summaryInfo.dailyGoalPoints =
        monthlyGoalPointsNum > 0 && this.summaryInfo.lastDayOfMonth > 0
          ? Math.round(monthlyGoalPointsNum / this.summaryInfo.lastDayOfMonth)
          : 0;

      if (todayData) {
        this.summaryInfo.personnelTO = todayData.ZB_PERSONNEL;
        this.summaryInfo.personnelActual = todayData.ZB_WORK_CNT;
        this.summaryInfo.todayMatch = todayData.MATCH;
      }

      this.summaryInfo.totalQty = data.reduce(
        (sum, d) => sum + parseInt(d.SALE_QTY || 0),
        0
      );
      this.summaryInfo.totalPoints = Math.round(
        data.reduce((sum, d) => sum + parseFloat(d.SUM_POINT_DAY || 0), 0)
      );
      this.summaryInfo.totalMatch = data.reduce(
        (sum, d) => sum + parseInt(d.MATCH || 0),
        0
      );

      const dayOfMonth = this.summaryInfo.currentDayOfMonth;
      const lastDayOfMonth = this.summaryInfo.lastDayOfMonth;

      if (dayOfMonth > 0) {
        this.summaryInfo.projectedQtySum = Math.round(
          (this.summaryInfo.totalQty / dayOfMonth) * lastDayOfMonth
        );
        this.summaryInfo.projectedPointSum = Math.round(
          (this.summaryInfo.totalPoints / dayOfMonth) * lastDayOfMonth
        );
        this.summaryInfo.avgMatch = (
          this.summaryInfo.totalMatch / dayOfMonth
        ).toFixed(1);
      } else {
        this.summaryInfo.projectedQtySum = 0;
        this.summaryInfo.projectedPointSum = 0;
        this.summaryInfo.avgMatch = "0.0";
      }
    },

    resetSummaryInfo() {
      this.summaryInfo = {
        monthlyGoalQty: null,
        dailyGoalQty: null,
        monthlyGoalPoints: null,
        dailyGoalPoints: null,
        personnelTO: null,
        personnelActual: null,
        todayMatch: null,
        totalQty: 0,
        totalPoints: 0,
        totalMatch: 0,
        projectedQtySum: null,
        projectedPointSum: null,
        avgMatch: null,
        currentDayOfMonth: new Date().getDate(),
        lastDayOfMonth: new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0
        ).getDate(),
      };
    },

    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },

    createEmptyWeek(weekNum) {
      return {
        week: weekNum,
        sun: null,
        mon: null,
        tue: null,
        wed: null,
        thu: null,
        fri: null,
        sat: null,
      };
    },

    // 왼쪽 그리드 (rowData2) 월별 셀 스타일 함수
    getMonthlyCellStyle(params) {
      if (!params.data || !params.data.year) return null;
      const yearLabel = params.data.year;

      if (yearLabel.includes("(수량차이)")) {
        return params.value < 0 ? { color: "blue" } : { color: "red" };
      }
      // 원본 코드의 params.value < 0 조건은 수량차이 외에는 의미가 없어보여 제거
      if (yearLabel.includes("(사업주명)"))
        return { backgroundColor: "#ffb895" };
      if (yearLabel.includes("(경영지도)"))
        return { backgroundColor: "#ffe8e8" };
      if (yearLabel.includes("(부점장명)"))
        return { backgroundColor: "#8bd7f3" };
      if (
        yearLabel.includes("(판매수량)") ||
        yearLabel.includes("(평균점수)") ||
        yearLabel.includes("(최고수량)")
      ) {
        return { backgroundColor: "yellow" };
      }
      return null;
    },

    // 왼쪽 그리드 (rowData2) 행 스타일 함수
    getRowStyleForGrid2(params) {
      if (!params.data || !params.data.year) return null;
      const currentYear = new Date().getFullYear();
      const yearLabel = params.data.year; // 예: "2023 (판매수량)"

      // 연도 부분만 추출 (정규식 사용)
      const yearMatch = yearLabel.match(/^(\d{4})/);
      if (!yearMatch) return null; // 연도 추출 실패 시 기본 스타일
      const year = parseInt(yearMatch[1]);

      // 연도 차이에 따라 배경색 적용
      const yearDiff = currentYear - year;
      if (yearDiff === 5) return { background: "#ead6bf" };
      if (yearDiff === 4) return { background: "#bef29e" };
      if (yearDiff === 3) return { background: "#fff0fd" };
      if (yearDiff === 2) return { background: "#dcf3fc" };
      if (yearDiff === 1) return { background: "#f1fcb8" };
      if (yearDiff === 0) return { background: "#c8fdd1" };

      return null; // 기본값
    },
  },
};
</script>

<style scoped>
/* --- 기본 스타일 (기존 스타일 유지 및 일부 수정) --- */
.header-info {
  display: flex;
  align-items: center;
  margin-bottom: 5px; /* 간격 조정 */
  font-size: 0.9rem; /* 폰트 크기 약간 줄임 */
  flex-wrap: wrap; /* 작은 화면에서 줄바꿈 허용 */
}

.header-table {
  /* width: 50%; */ /* 반응형에서는 고정 너비 제거 */
  flex: 1 1 300px; /* flex-grow, flex-shrink, flex-basis */
  min-width: 280px; /* 최소 너비 */
  border-collapse: collapse;
  table-layout: fixed;
  background-color: yellow;
  margin-right: 10px; /* 오른쪽 검색창과의 간격 */
  margin-bottom: 5px; /* 아래 요소와의 간격 */
}

.header-table th,
.header-table td {
  border: 1px solid black;
  text-align: center;
  padding: 3px 5px; /* 패딩 조정 */
}

.avaiCus {
  color: red;
  font-weight: bold;
}

.right-info {
  display: flex;
  justify-content: flex-end;
  flex: 1 1 150px; /* flex-grow, flex-shrink, flex-basis */
  min-width: 150px;
}

.right-info input {
  font-size: 0.9rem;
  padding: 4px 8px; /* 패딩 조정 */
  border: 1px solid #ccc;
  border-radius: 5px;
  max-width: 200px; /* 최대 너비 제한 */
}

/* 전체 레이아웃 컨테이너 */
/* --- 전체 레이아웃 --- */
.se-list-page-responsive {
  display: flex;
  flex-direction: column; /* right-section 위에, left-section 아래에 */
}


/* 왼쪽/오른쪽 섹션 기본 스타일 */
.left-section {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%; /* 전체 너비 사용 */
}

/* 오른쪽 섹션 아래에 간격 추가 */
.right-section {
  display: grid;
  grid-template-columns: 1.6fr 1.4fr; /* 그리드 2칸, 분석 1칸 비율 */
  box-sizing: border-box;
  width: 100%;
}

/* 공통 그리드 스타일 */
.grid-common {
  width: 100%;
  border: 1px solid #ccc; /* 그리드 테두리 */
}

/* 왼쪽 그리드 높이 */
.left-section .grid-common {
  height: 30rem;
  margin-bottom: 3px;
  border: 1px solid #ccc;
  width: 100%;
}

.right-section > .ag-grid-vue.grid-common {
  width: 100%; /* 할당된 그리드 셀 너비 채우기 */
  height: 12rem; /* 원하는 그리드 높이 지정 */
  /* height: 100%; */ /* 부모 .right-section에 height가 있다면 100% 사용 가능 */
  border: 1px solid #ccc;
  min-width: 0; /* Grid/Flex 아이템 축소 허용 */
}

.right-section > .analysis-section {
  width: 100%; /* 할당된 그리드 셀 너비 채우기 */
  /* height: 100%; */ /* 부모 .right-section에 height가 있다면 100% 사용 가능 */
  display: flex;
  flex-direction: row; /* 내부 테이블들은 세로로 쌓기 */
  overflow: auto; /* 내용 넘칠 경우 스크롤 (세로 스크롤 위주) */
  border: 1px solid lightblue; /* 확인용 테두리 */
}

.analysis-table th,
.analysis-table td {
  border: 1px solid black;
  text-align: center;
  white-space: nowrap; /* 셀 내용 줄바꿈 방지 */
}

.analysis-table th {
  background-color: #f0f0f0;
  font-weight: bold;
}

.analysis-table td {
  background-color: #ffffff;
}

/* 펼치기/접기 버튼 컨테이너 */
.toggle-button-container {
  text-align: right; /* 버튼 오른쪽 정렬 */
  margin-top: 5px;
}

/* 메인 테이블 컨테이너 */
.main-table-container {
  overflow-x: auto; /* 가로 스크롤 추가 */
  overflow-y: hidden; /* 세로 스크롤은 expanded 클래스에서 제어 */
  transition: max-height 0.3s ease;
  max-height: 40px; /* 접힌 상태 높이 */
  border: 1px solid #ccc; /* 테두리 추가 */
}

.main-table-container.expanded {
  max-height: 300px; /* 펼쳐진 상태 최대 높이 (조정 가능) */
  overflow-y: auto; /* 내용 넘칠 시 세로 스크롤 */
}

/* 메인 테이블 스타일 */
.main-table {
  width: 100%;
  min-width: 600px; /* 테이블 내용이 많으므로 최소 너비 지정 (스크롤 생성 유도) */
  border-collapse: collapse;
  font-size: 0.75rem; /* 폰트 크기 조정 */
}

.main-table th,
.main-table td {
  border: 1px solid black;
  text-align: center;
  padding: 4px; /* 패딩 조정 */
  white-space: nowrap; /* 셀 내용 줄바꿈 방지 */
}

.main-table th {
  background-color: #a0caf3;
  font-weight: bold;
  position: sticky; /* 헤더 고정 (컨테이너 스크롤 시) */
  top: 0;
  z-index: 1;
}

.main-table td {
  background-color: #ffffff;
}




.toggle-button {
  padding: 4px 8px;
  font-size: 0.8rem; /* 폰트 크기 조정 */
  cursor: pointer;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
}

.toggle-button:hover {
  background-color: #0056b3;
}

/* --- AG Grid 스타일 --- */
.ag-theme-balham {
  justify-content: center !important;
  text-align: center !important;
}

.ag-theme-balham .ag-header-cell-text {
  font-size: 0.7rem;
}
.ag-theme-balham .ag-header-cell {
  background-color: #f7f7f7;
  border: 0.5px solid #ddd;
  padding: 4px 2px;
}
.ag-theme-balham .ag-header-cell-label {
  white-space: normal !important;
  font-size: 1em ;
  line-height: 1.2;
}

.ag-theme-balham .ag-header {
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
  text-align: center !important;
}
.ag-theme-balham .ag-cell {
  font-size: 0.75rem;
  color: black;
  text-align: center !important;
  line-height: normal;
  padding: 0 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 0.5px solid #ddd;
  font-family: "Malgun Gothic", sans-serif;
}
.ag-theme-balham .ag-cell:last-child {
  border-right: none;
}

.ag-theme-balham .ag-header-container {
  background-color: #f0f0f0 !important;
  text-align: center !important;
}
.ag-theme-balham .ag-row-hover {
  background-color: #f0f8ff !important;
}
/* 합계 행 스타일 */
.ag-theme-balham .ag-floating-bottom-container .ag-row {
  background-color: #e8e8e8;
  font-weight: bold;
}
.ag-theme-balham .ag-floating-bottom-container .ag-cell {
  font-weight: bold;
  border-top: 1px solid #bbb;
}
/* 합계 행 특정 셀 숨기기 */
.ag-theme-balham .ag-floating-bottom-container .ag-cell[col-id="rowIndex"],
.ag-theme-balham .ag-floating-bottom-container .ag-cell[col-id="SHOP_NM"],
.ag-theme-balham .ag-floating-bottom-container .ag-cell[col-id="TRBIZ_TYPE"] {
  color: transparent;
  border-left: none;
  border-right: none;
}
/* 합계 행 병합된 셀 스타일 조정 */
/* .ag-theme-balham .ag-floating-bottom-container .ag-cell[col-id="VAN_BIZ_NO"],
.ag-theme-balham
  .ag-floating-bottom-container
  .ag-cell[col-id="TOTALPROFITSUM"] {
  /* 병합된 셀은 숨기지 않음 
} */

/* --- 반응형 스타일 (1024px 이하) --- */
@media (max-width: 1024px) {
  .header-info {
    font-size: 0.85rem;
  }
  .header-table {
    margin-right: 0;
  }
  .left-section .grid-common {
    height: 30rem;
  }
  .right-section .grid-common {
    height: 12rem;
  }
  .main-table-container.expanded {
    max-height: 250px;
  }
  .main-table,
  .analysis-table {
    font-size: 0.7rem;
  }
  .main-table th,
  .main-table td,
  .analysis-table th,
  .analysis-table td {
    padding: 3px;
  }
  .ag-theme-balham .ag-header-cell-text {
    font-size: 0.65rem;
    text-align: center;
  }
  .ag-theme-balham .ag-cell {
    font-size: 0.7rem;
    font-family: "Malgun Gothic", sans-serif;
  }
  .ag-theme-balham {
    --ag-row-height: 20px;
    --ag-header-height: 25px;
  }
  .ag-theme-balham .ag-header-cell {
    padding: 2px;
  }
}

/* --- 추가적인 작은 화면 대응 (예: 768px 이하) --- */
@media (max-width: 768px) {
  .header-info {
    font-size: 0.8rem;
  }
  .right-info input {
    max-width: 150px;
  }
  .left-section .grid-common {
    height: 18rem;
  }
  .right-section .grid-common {
    height: 10rem;
  }
  .main-table-container.expanded {
    max-height: 200px;
  }
  .main-table,
  .analysis-table {
    font-size: 0.65rem;
  }
  .ag-theme-balham .ag-header-cell-text {
    font-size: 0.6rem;
  }
  .ag-theme-balham .ag-cell {
    font-size: 0.65rem;
  }
  .ag-theme-balham {
    --ag-row-height: 18px;
    --ag-header-height: 22px;
    font-family: "Malgun Gothic", sans-serif;
  }
}
</style>
